import React, {useState} from 'react';

import DeleteAccountModal from '../../components/modals/DeleteAccountModal';
import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import config from '../../config';
import {handleLogoutPress} from '../../helpers/authHelpers';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import {Analytics} from '../../utils/analytics/analytics';
import {EventName} from '../../utils/analytics/events';
import {rewardsMarketingName} from '../../utils/rewards';

const AccountChooser = ({
  navigation,
}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_LOGGED_IN>) => {
  const {userStore} = useStores();

  const [deleteAccountModalVisible, setDeleteAccountModalVisible] =
    useState(false);

  const logOutText = 'Log Out';

  const handleDeleteAccountModalOK = async () => {
    try {
      const userId = userStore.id;

      await userStore.deleteUser();
      await userStore.logout();

      Analytics.logEvent({
        eventName: EventName.DeleteAccount,
        parameters: {
          user_id: userId,
        },
      });
      Analytics.clearUserSession();
    } catch (err) {
      console.error('error deleting user', err);
    }
  };

  const handleDeleteAccountModalCancel = () =>
    setDeleteAccountModalVisible(false);

  const handleMenuItemPress = (menuItem: any) => {
    if (menuItem.name === logOutText) {
      handleLogoutPress(navigation, userStore);
    } else {
      navigation.navigate(menuItem.target);
    }
  };

  const menuItems = [
    {target: AppRoute.ACCOUNT_DETAIL, name: 'Update Account'},
    {target: AppRoute.ACCOUNT_CHANGE_PASSWORD, name: 'Change Password'},
    ...(config.FF_LOYALTY_ENABLED
      ? [
          {target: AppRoute.ACCOUNT_REWARDS, name: rewardsMarketingName},
          {
            target: AppRoute.ACCOUNT_COMMUNICATIONS_PREFERENCES,
            name: 'Communications Preferences',
          },
        ]
      : []),
    {target: AppRoute.ACCOUNT_PAYMENT_METHOD, name: 'Payment Method'},
    {target: AppRoute.ACCOUNT_RECENT_ORDERS, name: 'Recent Orders'},
    {target: AppRoute.ACCOUNT_DELETE, name: 'Delete My Account'},
    {name: logOutText},
  ];

  return (
    <ContentView>
      <FlatListMenu data={menuItems} onPressItem={handleMenuItemPress} />
      <DeleteAccountModal
        open={deleteAccountModalVisible}
        okCallback={handleDeleteAccountModalOK}
        cancelCallback={handleDeleteAccountModalCancel}
      />
    </ContentView>
  );
};

export default AccountChooser;
